<template>
    
    <video autoplay controls width="100%" height="100%" ref="videodome" style= "object-fit: fill"></video>


</template>

<script>

    let Hls = require('hls.js')
    export default {
        name:"videoParam",
        props:{
            videoInfo:Object
        },

        data(){
            return{
               flvPlayer: null,
            }
        },
        created(){
           this.$nextTick(()=> {
                this.createVideo()
           })  
        },
        computed:{
           videoHlsUrl(){
               let info = this.videoInfo
               return info ?.videoDeviceAddrs ?.hls ?.streamAddr
              
           },
           videoFlvUrl(){
              let info = this.videoInfo
              return info ?.videoDeviceAddrs ?.flv ?.streamAddr
           },
        },
        beforeDestroy(){
          if(this.flvPlayer) {
            this.flvPlayer.destroy()
            this.flvPlayer = null
          }
        },
        methods:{
          createVideo(){
                if (this.$flv.isSupported())this.$nextTick(() => {
                    if (this.videoInfo.vendorName == "大华") {
                      this.createHls();
                    } else {
                       this.createFlv();
                    }
                }) 
          },
            // 加载hls视频流
          createHls(){
                if(this.flvPlayer) {
                    this.flvPlayer.destroy()
                    this.flvPlayer = null
                }
              let videoElement = this.$refs.videodome        
              let hls = new Hls();
              hls.loadSource(this.videoHlsUrl); //
              hls.attachMedia(videoElement);
              hls.on(Hls.Events.MANIFEST_PARSED, () => {
                    videoElement.play();
              });
              this.flvPlayer = hls
              
              
          },   
          createFlv(){
                if(this.flvPlayer) {
                    this.flvPlayer.destroy()
                    this.flvPlayer = null
                }
                let videoElement = this.$refs.videodome 
               
                let player = this.$flv.createPlayer({
                    type: 'flv',
                    url: this.videoFlvUrl
                });
            
                player.attachMediaElement(videoElement);
                player.load();
                player.play();
                this.flvPlayer = player

          },
          
        }
    }
</script>

<style lang="scss" scoped>

</style>